export enum ButtonIconPosition {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
